import React from 'react'
import { EcomProduct } from '../../../../models/axiosModel';
import globalStyles from "../../../../assets/styles/global.module.scss";
import contactStyles from "../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"; 
import styles from "../../../../assets/styles/componentStyles/productStyles/productStyles.module.scss"
import { Divider, Grid, Typography } from '@mui/material';
import { formatDateTime, getValueOrDefault } from '../../../../utils/constants';
import dayjs from 'dayjs';

interface ViewQRCodeDataPopupProps {
    selectedProduct: EcomProduct
} 

const ViewQRCodeDataPopup: React.FC<ViewQRCodeDataPopupProps> = (props) => {
    
    const { selectedProduct } = props;

    const innerHeight = window.innerHeight - 180;

    const formatTimestamp = (unix?: number | null) => {
        if (!unix) return getValueOrDefault(unix);
        return formatDateTime(unix * 1000, 'dmyNumTime');
    };

    return (
        <>
            <Grid container >
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={contactStyles.popupTitleTypography}>
                                {`QR Code Of ${selectedProduct?.ecom_product_name}`}
                            </Typography>
                        </Grid>

                        <Divider className={contactStyles.popupTitleDivider} /> 

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={`${contactStyles.popupBodyGridContainer} ${globalStyles.overflowAuto}`} gap={2} sx={{ maxHeight: `${innerHeight}px !important` }}>
                                {selectedProduct?.ecom_product_qr_code_data?.map((qrCode, index) => {
                                    return (
                                        <Grid item xs={12}>
                                            <Grid container gap={1} direction={'column'}>
                                                <Grid item xs={12} className={globalStyles.fullwidth}>
                                                    <Typography className={styles.qrCodeTitle}>
                                                        {`QR Code ${index + 1}`}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} className={`${globalStyles.fullwidth} ${styles.qrCodeDataGrid}`}>
                                                    <Grid container spacing={2}>
                                                        <Grid item lg={6} xs={12}>
                                                            <Grid container direction={'column'} gap={0.5}>
                                                                <Grid item xs={12}>
                                                                    <Typography className={styles.qrCodeFieldTitle}>
                                                                        Header
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Typography className={styles.qrCodeFieldValue}>
                                                                        {getValueOrDefault(qrCode?.ecom_product_qr_code_header)}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid item lg={6} xs={12}>
                                                            <Grid container direction={'column'} gap={0.5}>
                                                                <Grid item xs={12}>
                                                                    <Typography className={styles.qrCodeFieldTitle}>
                                                                        Description
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Typography className={styles.qrCodeFieldValue}>
                                                                        {getValueOrDefault(qrCode?.ecom_product_qr_code_description)}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid item lg={6} xs={12}>
                                                            <Grid container direction={'column'} gap={0.5}>
                                                                <Grid item xs={12}>
                                                                    <Typography className={styles.qrCodeFieldTitle}>
                                                                        Flag Expiry
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12} className={styles.booleanValGrid}>
                                                                    <Typography className={`${styles.qrCodeFieldValue} ${styles.booleanValChip} ${qrCode?.flag_expiry ? styles.booleanTrueChip : styles.booleanFalseChip}`}>
                                                                        {String(qrCode?.flag_expiry)?.toUpperCase()}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid item lg={6} xs={12}>
                                                            <Grid container direction={'column'} gap={0.5}>
                                                                <Grid item xs={12}>
                                                                    <Typography className={styles.qrCodeFieldTitle}>
                                                                        Flag Multiple Scan
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12} className={styles.booleanValGrid}>
                                                                    <Typography className={`${styles.qrCodeFieldValue} ${styles.booleanValChip} ${qrCode?.flag_multiple_scan ? styles.booleanTrueChip : styles.booleanFalseChip}`}>
                                                                        {String(qrCode?.flag_multiple_scan)?.toUpperCase()}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid item lg={6} xs={12}>
                                                            <Grid container direction={'column'} gap={0.5}>
                                                                <Grid item xs={12}>
                                                                    <Typography className={styles.qrCodeFieldTitle}>
                                                                        Start Time
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Typography className={styles.qrCodeFieldValue}>
                                                                        {formatTimestamp(qrCode?.ecom_product_qr_code_validity_start_timestamp_unix)}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid item lg={6} xs={12}>
                                                            <Grid container direction={'column'} gap={0.5}>
                                                                <Grid item xs={12}>
                                                                    <Typography className={styles.qrCodeFieldTitle}>
                                                                        End Time
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Typography className={styles.qrCodeFieldValue}>
                                                                        {formatTimestamp(qrCode?.ecom_product_qr_code_validity_end_timestamp_unix)}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ViewQRCodeDataPopup
